export default __webpack_public_path__ + "static/media/fontRoboto900_greek_ext.9c90814c.woff2";